import { render } from "./ThreadsHome.vue?vue&type=template&id=5e32bed6&scoped=true"
import script from "./ThreadsHome.vue?vue&type=script&lang=js"
export * from "./ThreadsHome.vue?vue&type=script&lang=js"

import "./ThreadsHome.vue?vue&type=style&index=0&id=5e32bed6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e32bed6"]])

export default __exports__